import { HttpClient } from '@angular/common/http';
import { Component, ErrorHandler, Injector, OnDestroy, OnInit } from '@angular/core';
import * as moment from 'moment';
import { Observable, catchError, throwError } from 'rxjs';

import { Constants } from '../../services/constants';

import { BlogCategory, BlogPosts } from './blogInterfaces';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss']
})
export class BlogComponent implements OnInit, OnDestroy {
  responseReceived = false;

  constructor(
    private httpClient: HttpClient,
    private injector: Injector
  ) {
    this.errorHandler = this.injector.get(ErrorHandler);
  }

  private errorHandler: ErrorHandler;

  blogPostsBackUp: any[] = [];
  blogPosts: any[] = [];
  postUsers: any[] = [];
  postCategories: BlogCategory[] = [];
  tags: any[] = [];
  searchText = '';

  postLoadCount = 3;
  catLoadCount = 6;
  currentPage = 1;
  startPage = 0;
  endPage = 1;
  totalPage = 20;
  loader = true;
  stopped = false;

  ngOnInit(): void {
    this.getUsers();
    this.getCategories();
    this.getTags();
    this.getPosts();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: any) => {
      try {
        subscription.unsubscribe();
      } catch (error) {
        console.info('');
      }
    });
  }

  readMorePosts() {
    this.postLoadCount -= 3;
    if (this.postLoadCount >= this.blogPosts.length) {
      this.postLoadCount = this.blogPosts.length;
    }
  }

  loadMoreCats() {
    this.catLoadCount += 5;
    if (this.catLoadCount >= this.postCategories.length) {
      this.catLoadCount = this.postCategories.length;
    }
  }

  getPostList() {
    if (this.searchText) {
      const listToReturn: any[] = [];

      this.allPageData.forEach((blog_item) => {
        if (blog_item.title.rendered.toLowerCase().includes(this.searchText.toLowerCase())) {
          listToReturn.push(blog_item);
        } else {
          blog_item.categories.forEach((tag_id) => {
            if (this.getTagsById(tag_id).toLowerCase().includes(this.searchText.toLowerCase())) {
              listToReturn.push(blog_item);
            }
          });
        }
      });

      return listToReturn;
    } else {
      return this.pageData[this.currentPage];
    }
  }

  getTagsById(tag: number) {
    const index = this.postCategories.findIndex((x) => x.id === tag);
    if (index > -1) {
      return this.postCategories[index].name || '';
    } else {
      return '';
    }
  }

  pageData: any = {};
  pageLength: any = [];
  pageCount = 1;
  allPageData: BlogPosts[] = [];
  currentPageCall = 1;
  subscriptions: any[] = [];

  getPosts() {
    const sub1 = this.getAllPosts(this.currentPageCall).subscribe({
      next: (response) => {
        this.responseReceived = true;
        if (Array.isArray(response) && response.length > 0) {
          this.pageData[this.pageCount] = response;
          this.pageLength.push(this.pageCount);
          this.pageCount += 1;
          this.allPageData = [...this.allPageData, ...response];
          this.currentPageCall += 1;
          this.getPosts();
        } else {
          this.hidePagination = false;
        }
        this.totalPage = this.pageCount - 1;
        this.updatePage(1);
      },
      error: (error) => {
        console.info(error);
        this.totalPage = this.pageCount - 1;
        this.updatePage(1);
        this.hidePagination = false;
        this.loader = false;
      }
    });

    this.subscriptions.push(sub1);
  }

  hidePagination = true;

  checkPages() {
    return Object.keys(this.pageData).length > 1 && !this.hidePagination;
  }

  getPostsBackup() {
    const sub1 = this.getAllPosts().subscribe({
      next: (response) => {
        this.blogPosts = response || [];
        this.blogPostsBackUp = [...this.blogPosts];
      }
    });
    this.subscriptions.push(sub1);
  }

  usersPage = 1;
  getUsers() {
    const sub1 = this.getUsersPage(this.usersPage).subscribe({
      next: (response) => {
        if (Array.isArray(response) && response.length > 0) {
          this.postUsers = [...this.postUsers, ...response] || [];
          this.usersPage += 1;
          this.getUsers();
        }
      },
      error: (error) => {
        console.info(error);
      }
    });

    this.subscriptions.push(sub1);
  }

  categoriesPage = 1;
  getCategories() {
    const sub1 = this.getCategoriesPage(this.categoriesPage).subscribe({
      next: (response) => {
        if (Array.isArray(response) && response.length > 0) {
          this.categoriesPage += 1;
          this.postCategories = [...this.postCategories, ...response] || [];
          this.getCategories();
        }
      },
      error: (error) => {
        console.info(error);
      }
    });
    this.subscriptions.push(sub1);
  }

  tagsPage = 1;
  getTags() {
    const sub1 = this.getTagsPage(this.tagsPage).subscribe({
      next: (response) => {
        if (Array.isArray(response) && response.length > 0) {
          this.tags = [...this.tags, ...response] || [];
          this.tagsPage += 1;
          this.getTags();
        }
      },
      error: (error) => {
        console.info(error);
      }
    });
    this.subscriptions.push(sub1);
  }

  getUserById(id: number) {
    const index = this.postUsers.findIndex((x) => x.id === id);
    if (index > -1) {
      return this.postUsers[index].name;
    }
    return 'Avaana Freelance Writer';
  }

  getDateFormat(value: string) {
    const newFormat = new Date(value);
    return moment(newFormat).format('DD/MM/YYYY');
  }

  getDateFormat1(value: string) {
    return moment(value).format('DD MMM');
  }

  getAllPosts(count = 1): Observable<any> {
    const endPoint = '?per_page=6&page=' + count;
    return this.httpClient.get(Constants.BLOG_POST_API_URL + endPoint).pipe(catchError(this.handleError.bind(this)));
  }

  getUsersPage(count: number): Observable<any> {
    const endPoint = '?per_page=100&page=' + count;
    return this.httpClient.get(Constants.BLOG_USER_API_URL + endPoint).pipe(catchError(this.handleError.bind(this)));
  }

  getTagsPage(count: number): Observable<any> {
    const endPoint = '?per_page=100&page=' + count;
    return this.httpClient.get(Constants.BLOG_TAGS_API_URL + endPoint).pipe(catchError(this.handleError.bind(this)));
  }

  getCategoriesPage(count: number): Observable<any> {
    const endPoint = '?per_page=100&page=' + count;
    return this.httpClient
      .get(Constants.BLOG_CATEGORIES_API_URL + endPoint)
      .pipe(catchError(this.handleError.bind(this)));
  }

  getAllPopularPosts(): Observable<any> {
    const endPoint = '?per_page=3&page=1';
    return this.httpClient.get(Constants.BLOG_POPULAR_POSTS + endPoint).pipe(catchError(this.handleError.bind(this)));
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage -= 1;
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPage) {
      this.currentPage += 1;
    }
  }

  updatePage(page: number) {
    this.currentPage = page;
    this.startPage = this.currentPage - 2;
    this.endPage = this.currentPage + 2;

    if (this.startPage <= 0) {
      this.endPage -= this.startPage - 1;
      this.startPage = 1;
    }

    if (this.endPage >= this.totalPage) {
      this.endPage = this.totalPage;
      this.startPage = this.endPage - 4;
    }
  }

  private handleError(error: any): Observable<never> {
    // Call the global error handler
    this.errorHandler.handleError(error);

    // Re-throw the error so it can be caught by the component's subscribe error handler
    return throwError(() => error);
  }
}
